import React, { useEffect, useState } from "react";
import axios from "axios";
import API from "../api";
import "./ListaFacturasPDF.css";

const ListaFacturasPDF = () => {
  const [facturas, setFacturas] = useState([]);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    const fetchFacturas = async () => {
      const res = await axios.get(`${API}/facturas-subidas`);
      setFacturas(res.data);
    };
    fetchFacturas();
  }, []);

  const descargarPDF = async (id, nombre) => {
    const res = await axios.get(`${API}/facturas-subidas/${id}/pdf`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", nombre);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const facturasFiltradas = facturas.filter((factura) => {
    const busquedaLower = busqueda.toLowerCase();
    return (
      factura.cliente?.toLowerCase().includes(busquedaLower) ||
      factura.trabajo?.toLowerCase().includes(busquedaLower) ||
      new Date(factura.fecha).toLocaleDateString().includes(busqueda)
    );
  });

  return (
    <div className="lista-facturas">
  <div className="titulo-facturas">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#209978"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <line x1="10" y1="9" x2="8" y2="9" />
    </svg>
    <h2>Facturas PDF Subidas</h2>
  </div>

  {/* Buscador moderno */}
  <div className="container-input">

  <input
    type="text"
    placeholder="Buscar"
    name="text"
    className="input"
    value={busqueda}
    onChange={(e) => setBusqueda(e.target.value)}
  />
  <svg fill="#000000" width="20px" height="20px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
    <path d="M790.588 1468.235c-373.722 0-677.647-303.924-677.647-677.647 0-373.722 303.925-677.647 677.647-677.647 373.723 0 677.647 303.925 677.647 677.647 0 373.723-303.924 677.647-677.647 677.647Zm596.781-160.715c120.396-138.692 193.807-319.285 193.807-516.932C1581.176 354.748 1226.428 0 790.588 0S0 354.748 0 790.588s354.748 790.588 790.588 790.588c197.647 0 378.24-73.411 516.932-193.807l516.028 516.142 79.963-79.963-516.142-516.028Z" fillRule="evenodd" />
  </svg>
</div>


      <table className="tabla-pc">
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Trabajo</th>
            <th>Fecha</th>
            <th>Archivo</th>
          </tr>
        </thead>
        <tbody>
          {facturasFiltradas.map((factura) => (
            <tr key={factura._id}>
              <td>{factura.cliente}</td>
              <td>{factura.trabajo}</td>
              <td>{new Date(factura.fecha).toLocaleDateString()}</td>
              <td>
                <button
                  className="button"
                  onClick={() => descargarPDF(factura._id, factura.nombreArchivo)}
                >
                  <span className="button__text">Descargar</span>
                  <span className="button__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                      <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                      <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                      <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
                    </svg>
                  </span>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

         <div className="tarjetas-movil">
        {facturasFiltradas.map((factura) => (
          <div className="factura-card" key={factura._id}>
            <p><strong>📄 Cliente:</strong> {factura.cliente}</p>
            <p><strong>🧰 Trabajo:</strong> {factura.trabajo}</p>
            <p><strong>📅 Fecha:</strong> {new Date(factura.fecha).toLocaleDateString()}</p>
            <button
              className="button"
              onClick={() => descargarPDF(factura._id, factura.nombreArchivo)}
            >
              <span className="button__text">Descargar</span>
              <span className="button__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                  <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                  <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                  <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
                </svg>
              </span>
            </button>
          </div>
        ))}
      </div>

      {/* Botón para volver al inicio */}
    <div className="boton-volver">
  <a href="/" className="boton-inicio">🏠 Volver al Inicio</a>
</div>



    </div>
  );
};


export default ListaFacturasPDF;
